import Vue from 'vue';
import Vuex from 'vuex';
import {getStoredPushContext} from '../services/push.js';

Vue.use(Vuex);

// Login baru menimpa sesi lama di browser yang sama (mis. SSO dari
// frontend GCC) tanpa melewati logout. Lepas push token & cabut token API
// milik sesi lama memakai kredensial lamanya — setelah header diganti ke
// sesi baru, endpoint unregister/logout tidak lagi beroperasi atas nama
// akun lama. Fire-and-forget: kegagalan (mis. token lama sudah kedaluwarsa)
// tidak boleh menghalangi login baru; kepemilikan push token tetap pindah
// lewat re-register paksa di syncPushToken.
function endPreviousSession(previousToken) {
    const headers = {Authorization: 'Bearer ' + previousToken};
    axios.post('api/push/unregister', getStoredPushContext(), {headers: headers}).catch(function () {
    }).finally(function () {
        axios.post('api/auth/logout', {}, {headers: headers}).catch(function () {
        });
    });
}

const store = new Vuex.Store({
    state: {
        user: false,
        permissions: {},
        settings: false,
        notificationUnreadTotal: 0,
    },
    mutations: {
        setSettings(state, data) {
            state.settings = data;
        },
        login(state, response) {
            const previousToken = localStorage.getItem('token');
            if (previousToken && previousToken !== response.token) {
                endPreviousSession(previousToken);
            }
            state.user = response.user;
            state.permissions = response.user.role.permissions;
            localStorage.setItem('token', response.token);
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.token;
            // Echo membaca header auth dari objek yang dibekukan saat bundle
            // dimuat (user belum login -> header kosong). Pusher-js membaca
            // objek ini lagi saat request /broadcasting/auth, jadi cukup
            // di-mutate di sini agar channel private tidak 401 setelah login.
            if (window.Echo && window.Echo.options && window.Echo.options.auth) {
                window.Echo.options.auth.headers.Authorization = 'Bearer ' + response.token;
            }
        },
        logout(state) {
            const finalizeLogout = function () {
                axios.post('api/auth/logout').finally(function () {
                    state.user = false;
                    state.permissions = {};
                    state.notificationUnreadTotal = 0;
                    delete window.axios.defaults.headers.common.Authorization;
                    if (window.Echo && window.Echo.options && window.Echo.options.auth) {
                        window.Echo.options.auth.headers.Authorization = '';
                    }
                    localStorage.removeItem('token');
                });
            };

            import('@/services/push').then(function (module) {
                return module.unregisterPushToken();
            }).catch(function () {
                // Ignore push unregister issues during logout.
            }).finally(function () {
                finalizeLogout();
            });
        },
        setUser(state) {
            if (localStorage.getItem('token')) {
                axios.get('api/auth/user').then(function (response) {
                    state.user = response.data;
                    state.permissions = response.data.role.permissions;
                });
            }
        },
        updateUser(state, response) {
            state.user = response;
            state.permissions = response.role.permissions;
        },
        setNotificationUnreadTotal(state, total) {
            state.notificationUnreadTotal = Number.isFinite(total) ? total : 0;
        },
    }
});

export default store;

